import { render, staticRenderFns } from "./IdeaBulk.vue?vue&type=template&id=3ad7db32&"
import script from "./IdeaBulk.vue?vue&type=script&lang=js&"
export * from "./IdeaBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports